var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto pa-5",class:_vm.className,attrs:{"width":_vm.width}},[_c('v-card-title',{staticClass:"justify-content-center"},[_vm._t("card-title")],2),_c('v-card-text',[_c('v-container',[_vm._t("card-content")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }